import React from 'react'
import { useRouter } from '../../application/router/useRouter'

export const ScrollToTop: React.FC = () => {
  const { location } = useRouter()
  const { pathname } = location
  React.useEffect(() => window.scrollTo(0, 0), [pathname])
  return null
}
